import * as React from 'react';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';


interface IEnhancedTable {  
    children?: React.ReactNode;    
    tableToolBar?: React.ReactNode;
    tableHeader?: React.ReactNode;
    tableRows?: React.ReactNode;
    pagination?: boolean;
    totalRows?: number;     
    page?: number;
    rowsPerPage?: number;
    handleChangePage: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => void;
    handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const EnhancedTable = (props: IEnhancedTable) => {

    const { 
        tableToolBar, tableHeader, tableRows, pagination, totalRows, page, rowsPerPage, 
        handleChangePage, handleChangeRowsPerPage 
    } = props;
        
    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                {tableToolBar}
                <TableContainer>
                    <Table
                        sx={{ minWidth: 750 }}                        
                        size={'medium'}
                    >
                        {tableHeader}
                        <TableBody>
                            {tableRows}
                        </TableBody>
                    </Table>
                </TableContainer>
                {pagination &&
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={totalRows ?? 0}
                    rowsPerPage={rowsPerPage ?? 0}
                    page={page ?? 0}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />}
            </Paper>
        </Box>
    );
};

export default EnhancedTable;
